import {
  BooleanEnum,
  ProfileCorporateKYCControlExemptionReason,
  ProfileCorporateKYCRegulatedStatus,
  ProfileInvestingTotalInvestableAssets,
  ProfileInvestingTotalAssets,
  ProfileInvestingAssetAllocationToCrypto,
  ProfileInvestingInvestmentExperienceCrypto,
  ProfileInvestingInvestmentStrategyCrypto,
  ProfileInvestingInitialDepositSource,
  ProfileInvestingOngoingDepositSource,
  ProfileInvestingFrequencyOfCryptoTransactions,
  ProfileInvestingCryptoInvestmentPlans,
  ProfileInvestingTradesPerMonth,
  ProfileInvestingUsdValueOfCrypto,
  ProfileInvestingFrequencyOfTransactions,
  ProfileInvestingMonthlyCryptoInvestmentDeposit,
  ProfileInvestingMonthlyInvestmentDeposit,
  ProfileInvestingMonthlyCryptoDeposits,
  ProfileInvestingMonthlyDeposits,
  ProfileInvestingMonthlyCryptoInvestmentWithdrawal,
  ProfileInvestingMonthlyInvestmentWithdrawal,
  ProfileInvestingMonthlyCryptoWithdrawals,
  ProfileInvestingMonthlyWithdrawals,
  IndividualCustomerUsResidencyStatus,
  CorporationCustomerCorporateEntityType,
  IndividualEmploymentStatus,
  ProfileCorporateKYCEngageInActivities,
  ProfileCorporateKYCPrimaryBusiness,
  ProfileInvestingPrimarySourceOfFunds,
  ProfileKYCVendorsAndCounterparties,
  BridgeMostRecentOccupation,
  PrimaryPurposeEnum,
} from "@/utils/dto/extracted_enums";

export const EnumsOnboarding = {
  mostRecentOccupation: [
    "BridgeMostRecentOccupation",
    BridgeMostRecentOccupation,
  ],
  occupation: ["BridgeMostRecentOccupation", BridgeMostRecentOccupation],
  primaryPurpose: ["PrimaryPurposeEnum", PrimaryPurposeEnum],
  vendorsAndCounterparties: [
    "ProfileKYCVendorsAndCounterparties",
    ProfileKYCVendorsAndCounterparties,
  ],
  isCharitable: ["BooleanEnum", BooleanEnum],
  isDao: ["BooleanEnum", BooleanEnum],
  transmitsCustomerFunds: ["BooleanEnum", BooleanEnum],
  newYorkOffice: ["BooleanEnum", BooleanEnum],
  regulatedStatus: [
    "ProfileCorporateKYCRegulatedStatus",
    ProfileCorporateKYCRegulatedStatus,
  ],
  controlExemptionReason: [
    "ProfileCorporateKYCControlExemptionReason",
    ProfileCorporateKYCControlExemptionReason,
  ],
  totalInvestableAssets: [
    "ProfileInvestingTotalInvestableAssets",
    ProfileInvestingTotalInvestableAssets,
  ],
  totalAssets: [
    "ProfileInvestingTotalAssets",
    ProfileInvestingUsdValueOfCrypto,
  ],
  assetAllocationToCrypto: [
    "ProfileInvestingAssetAllocationToCrypto",
    ProfileInvestingAssetAllocationToCrypto,
  ],
  investmentExperienceCrypto: [
    "ProfileInvestingInvestmentExperienceCrypto",
    ProfileInvestingInvestmentExperienceCrypto,
  ],
  investmentStrategyCrypto: [
    "ProfileInvestingInvestmentStrategyCrypto",
    ProfileInvestingInvestmentStrategyCrypto,
  ],
  initialDepositSource: [
    "ProfileInvestingInitialDepositSource",
    ProfileInvestingInitialDepositSource,
  ],
  ongoingDepositSource: [
    "ProfileInvestingOngoingDepositSource",
    ProfileInvestingOngoingDepositSource,
  ],
  frequencyOfCryptoTransactions: [
    "ProfileInvestingFrequencyOfCryptoTransactions",
    ProfileInvestingFrequencyOfCryptoTransactions,
  ],
  cryptoInvestmentPlans: [
    "ProfileInvestingCryptoInvestmentPlans",
    ProfileInvestingCryptoInvestmentPlans,
  ],
  tradesPerMonth: [
    "ProfileInvestingTradesPerMonth",
    ProfileInvestingTradesPerMonth,
  ],
  usdValueOfCrypto: [
    "ProfileInvestingUsdValueOfCrypto",
    ProfileInvestingUsdValueOfCrypto,
  ],
  frequencyOfTransactions: [
    "ProfileInvestingFrequencyOfTransactions",
    ProfileInvestingFrequencyOfTransactions,
  ],
  monthlyCryptoInvestmentDeposit: [
    "ProfileInvestingMonthlyCryptoInvestmentDeposit",
    ProfileInvestingMonthlyCryptoInvestmentDeposit,
  ],
  monthlyInvestmentDeposit: [
    "ProfileInvestingMonthlyInvestmentDeposit",
    ProfileInvestingMonthlyInvestmentDeposit,
  ],
  monthlyCryptoDeposits: [
    "ProfileInvestingMonthlyCryptoDeposits",
    ProfileInvestingMonthlyCryptoDeposits,
  ],
  monthlyDeposits: [
    "ProfileInvestingMonthlyDeposits",
    ProfileInvestingMonthlyDeposits,
  ],
  monthlyCryptoInvestmentWithdrawal: [
    "ProfileInvestingMonthlyCryptoInvestmentWithdrawal",
    ProfileInvestingMonthlyCryptoInvestmentWithdrawal,
  ],
  monthlyInvestmentWithdrawal: [
    "ProfileInvestingMonthlyInvestmentWithdrawal",
    ProfileInvestingMonthlyInvestmentWithdrawal,
  ],
  monthlyCryptoWithdrawals: [
    "ProfileInvestingMonthlyCryptoWithdrawals",
    ProfileInvestingMonthlyCryptoWithdrawals,
  ],
  monthlyWithdrawals: [
    "ProfileInvestingMonthlyWithdrawals",
    ProfileInvestingMonthlyWithdrawals,
  ],
  usResidencyStatus: [
    "IndividualCustomerUsResidencyStatus",
    IndividualCustomerUsResidencyStatus,
  ],
  corporateEntityType: [
    "CorporationCustomerCorporateEntityType",
    CorporationCustomerCorporateEntityType,
  ],
  engageInActivities: [
    "ProfileCorporateKYCEngageInActivities",
    ProfileCorporateKYCEngageInActivities,
  ],
  employmentStatus: ["IndividualEmploymentStatus", IndividualEmploymentStatus],
  usdValueOfFiat: [
    "ProfileInvestingUsdValueOfCrypto",
    ProfileInvestingUsdValueOfCrypto,
  ],
  primaryBusiness: [
    "ProfileCorporateKYCPrimaryBusiness",
    ProfileCorporateKYCPrimaryBusiness,
  ],
  primarySourceOfFunds: [
    "ProfileInvestingPrimarySourceOfFunds",
    ProfileInvestingPrimarySourceOfFunds,
  ],
  performTransfersWithUnhostedWallets: ["BooleanEnum", BooleanEnum],
  tradeInternationally: ["BooleanEnum", BooleanEnum],
};

export const fieldsOnboarding = [
  "firstName",
  "middleName",
  "lastName",
  "dateOfBirth",
  "emailAddress",
  "telephoneNumber",
  "taxReferenceNumber",
  "passportNumber",
  "unitNumber",
  "addressLine1",
  "addressLine2",
  "addressLine3",
  "citizenship",
  "nationality",
  "country",
  "city",
  "state",
  "postalCode",
  "countryCode",
  "registeredName",
  "tradingName",
  "registeredNumber",
  "websiteAddress",
  "stateOfIncorporation",
  "countryOfIncorporation",
  "corporateEntityType",
  "establishedOn",
  "descriptionOfBusinessNature",
  "naics",
  "naicsDescription",
  "totalInvestableAssets",
  "totalAssets",
  "assetAllocationToCrypto",
  "investmentExperienceCrypto",
  "investmentStrategyCrypto",
  "initialDepositSource",
  "ongoingDepositSource",
  "frequencyOfCryptoTransactions",
  "cryptoInvestmentPlans",
  "tradesPerMonth",
  "usdValueOfCrypto",
  "frequencyOfTransactions",
  "monthlyCryptoInvestmentDeposit",
  "monthlyInvestmentDeposit",
  "monthlyCryptoDeposits",
  "monthlyDeposits",
  "monthlyCryptoInvestmentWithdrawal",
  "monthlyInvestmentWithdrawal",
  "monthlyCryptoWithdrawals",
  "monthlyWithdrawals",
  "businessNature",
  "newYorkOffice",
  "regulatedStatus",
  "regulationAgency",
  "regulationAgencyNumber",
  "controlExemptionReason",
  "corporateEntityTypeDescription",
  "vendorsAndCounterparties",
  "isCharitable",
  "employmentStatus",
  "employmentDescription",
  "employerName",
  "occupation",
  "usdValueOfFiat",
  "fundsSendReceiveJurisdictions",
  "engageInActivities",
  "primarySourceOfFunds",
  "primarySourceOfFundsDescription",
  "businessJurisdictions",
  "primaryBusiness",
  "initialDepositSourceCryptoDetails",
  "initialDepositSourceFiatDetails",
  "investmentProceedsUse",
  "expectedCryptoAssets",
  "performTransfersWithUnhostedWallets",
  "knownUnhostedWalletAddresses",
  "tradeInternationally",
  "tradeJurisdictions",
];

export const addressFields = [
  "countryCode",
  "country",
  "state",
  "city",
  "addressLine1",
  "addressLine2",
  "addressLine3",
  "postalCode",
  "unitNumber",
];

export const kycFields = [
  "primaryBusiness",
  "descriptionOfBusinessNature",
  "isCharitable",
  "businessJurisdictions",
  "fundsSendReceiveJurisdictions",
  "newYorkOffice",
  "engageInActivities",
  "regulatedStatus",
  "regulationAgency",
  "regulationAgencyRegulationNumber",
  "controlExemptionReason",
  "vendorsAndCounterparties",
];

export const investmentProfileFields = [
  "primarySourceOfFunds",
  "primarySourceOfFundsDescription",
  "totalInvestableAssets",
  "totalAssets",
  "assetAllocationToCrypto",
  "investmentExperienceCrypto",
  "investmentStrategyCrypto",
  "initialDepositSource",
  "initialDepositSourceCryptoDetails",
  "initialDepositSourceFiatDetails",
  "ongoingDepositSource",
  "frequencyOfCryptoTransactions",
  "cryptoInvestmentPlans",
  "investmentProceedsUse",
  "expectedCryptoAssets",
  "performTransfersWithUnhostedWallets",
  "knownUnhostedWalletAddresses",
  "tradesPerMonth",
  "usdValueOfCrypto",
  "usdValueOfFiat",
  "frequencyOfTransactions",
  "monthlyCryptoInvestmentDeposit",
  "monthlyInvestmentDeposit",
  "monthlyCryptoDeposits",
  "monthlyDeposits",
  "monthlyCryptoInvestmentWithdrawal",
  "monthlyInvestmentWithdrawal",
  "monthlyCryptoWithdrawals",
  "monthlyWithdrawals",
  "tradeInternationally",
  "tradeJurisdictions",
];
